import { createSlice } from "@reduxjs/toolkit";

import InitialState from "../../types/appDialog";

const initialState: InitialState = {
    dialog: 'hide',
}; 

export const appDialogSlice = createSlice({
    name: "appDialog",
    initialState: initialState,
    reducers: {
        openDialog: (state, action) => {
            state.dialog = action.payload;
        },
        closeDialog: (state, action) => {
            state.dialog = action.payload;
        },
    },
});

export const { 
    openDialog, 
    closeDialog 
} = appDialogSlice.actions;

export default appDialogSlice.reducer;